export default (init) => {
  if (document.readyState === `loading`) {
    document.addEventListener(`DOMContentLoaded`, init)
  } else {
    init()
  }
}
